export default [
  {
    path: '/analises-banco-precos',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Analises Banco Precos Historico',
        path: 'historico',
        component: () => import('@/views/analisesBancoPrecos/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Análises Banco Preços' }]
        }
      },
      {
        name: 'Analises Banco Precos Add',
        path: 'edit',
        component: () => import('@/views/analisesBancoPrecos/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Análises Banco Preços', path: '/analises-banco-precos/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Analises Banco Precos Edit',
        path: 'edit/:id',
        component: () => import('@/views/analisesBancoPrecos/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Análises Banco Preços', path: '/analises-banco-precos/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
